export default __webpack_public_path__ + "static/media/s7.baeb5f14.png";